/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PlanSettings
 */
export interface PlanSettings {
  /**
   *
   * @type {string}
   * @memberof PlanSettings
   */
  planId: string;
  /**
   *
   * @type {boolean}
   * @memberof PlanSettings
   */
  hideCertificates: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PlanSettings
   */
  hideRegions: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PlanSettings
   */
  hideSpecies: boolean;
  /**
   *
   * @type {string}
   * @memberof PlanSettings
   */
  shortTermGrowthModelType: PlanSettingsShortTermGrowthModelTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PlanSettings
   */
  shortTermGrowthTransitionStart: number;
  /**
   *
   * @type {number}
   * @memberof PlanSettings
   */
  shortTermGrowthTransitionStop: number;
  /**
   *
   * @type {boolean}
   * @memberof PlanSettings
   */
  useShortTermTemperature: boolean;
  /**
   *
   * @type {string}
   * @memberof PlanSettings
   */
  country: PlanSettingsCountryEnum;
  /**
   *
   * @type {number}
   * @memberof PlanSettings
   */
  nokToUsdExchangeRate: number;
  /**
   *
   * @type {boolean}
   * @memberof PlanSettings
   */
  shouldSynchronize: boolean;
}

export const PlanSettingsShortTermGrowthModelTypeEnum = {
  SimpleEwma: 'simple_ewma',
  DynamicEwma: 'dynamic_ewma',
  NgrResidualEts: 'ngr_residual_ets',
  UseTenantSettings: 'use_tenant_settings',
} as const;

export type PlanSettingsShortTermGrowthModelTypeEnum =
  (typeof PlanSettingsShortTermGrowthModelTypeEnum)[keyof typeof PlanSettingsShortTermGrowthModelTypeEnum];
export const PlanSettingsCountryEnum = {
  Norway: 'NORWAY',
  Chile: 'CHILE',
} as const;

export type PlanSettingsCountryEnum = (typeof PlanSettingsCountryEnum)[keyof typeof PlanSettingsCountryEnum];
